module.exports = __webpack_public_path__ + "svg/travel-information_e-station.svg";